var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('RCard',{staticClass:"section-centered"},[(_vm.isApi)?[_c('router-view')]:[(_vm.error)?_c('div',{staticClass:"red"},[_vm._v(_vm._s(_vm.error))]):_c('div',[_vm._v("...")])]],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }